import { KNOWLEDGE_BUILDERS_ACTIONS } from 'app/store/actions/media/knowledge.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import { KnowledgeBuildersListInitialState } from 'app/types/theater-reducers.types'

const initialState: KnowledgeBuildersListInitialState = {
  data: [],
  loading: true,
  error: false,
}

const KnowledgeBuilders = baseRequestReducer(
  initialState,
  KNOWLEDGE_BUILDERS_ACTIONS
)

export default KnowledgeBuilders
